import type { OrderConfirmationInput } from "../../domain/order-confirmation";
import {
  OrderConfirmationError,
  orderConfirmationHttpError,
  parseOrderConfirmationWorkspace,
  parseOrderConfirmationSession,
  parseOrderConfirmationResponse
} from "./order-confirmation-contracts";
async function request(path: string, init?: RequestInit): Promise<unknown> {
  let response: Response;
  try {
    response = await fetch(path, { ...init, credentials: "same-origin", headers: { "content-type": "application/json", ...init?.headers } });
  } catch {
    throw new OrderConfirmationError("İşlem sonucu doğrulanamadı. Bağlantınızı kontrol edip aynı işlemi tekrar deneyin.", true);
  }
  const body: unknown = await response.json().catch(() => null);
  if (!response.ok) throw orderConfirmationHttpError(body, response.status);
  return body;
}
export const orderConfirmationGateway = {
  async exchange(token: string) { parseOrderConfirmationSession(await request("/order-portal/api/access/exchange", { method: "POST", body: JSON.stringify({ token }) })); },
  async current(signal?: AbortSignal) { return parseOrderConfirmationWorkspace(await request("/order-portal/api/current", { signal })); },
  async respond(input: OrderConfirmationInput, key: string) {
    return parseOrderConfirmationResponse(await request("/order-portal/api/respond", { method: "POST", headers: { "idempotency-key": key }, body: JSON.stringify(input) }), input);
  },
};
